import Vue from "vue";
import axios from "axios";
import api from "@/api.js";

export default {
  sendReportIssue: async ({ rootState }, data) => {
    // const response = await api.post(`mailing/sendReportIssue`, data);
    const response = await axios.post(
      `${rootState.axios.API}mailing/sendReportIssue`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
  },
  sendSalesEnquiry: async ({ commit, rootState }, data) => {
    const response = await api.post(`mailing/sendSalesEnquiry`, data);
    // const response = await axios.post(
    //   `${rootState.axios.API}mailing/sendSalesEnquiry`,
    //   data
    // );
    return response;
  },
  sendGeneralEnquiry: async ({ commit, rootState }, data) => {
    const response = await api.post(`mailing/sendGeneralEnquiry`, data);
    // const response = await axios.post(
    //   `${rootState.axios.API}mailing/sendGeneralEnquiry`,
    //   data
    // );
  },
  sendSupplierJoinEnquiry: async ({ commit, rootState }, data) => {
    const reponse = await api.post(`mailing/sendSupplierJoinEnquiry`, data);
    // const response = await axios.post(
    //   `${rootState.axios.API}mailing/sendSupplierJoinEnquiry`,
    //   data
    // );
  },
  sendGoodCauseJoinEnquiry: async ({ commit, rootState }, data) => {
    const response = await api.post(`mailing/sendGoodCauseJoinEnquiry`, data);
    // const response = await axios.post(
    //   `${rootState.axios.API}mailing/sendGoodCauseJoinEnquiry`,
    //   data
    // );
  },
  sendImpactBusinessJoinEnquiry: async ({ commit, rootState }, data) => {
    const response = await api.post(
      `mailing/sendImpactBusinessJoinEnquiry`,
      data
    );
    // const response = await axios.post(
    //   `${rootState.axios.API}mailing/sendImpactBusinessJoinEnquiry`,
    //   data
    // );
    return response.data;
  },
  sendAffiliateLinkNotice: async ({ commit, rootState }, data) => {
    const response = await api.post(`mailing/sendAffiliateLinkNotice`, data);
    // const response = await axios.post(
    //   `${rootState.axios.API}mailing/sendAffiliateLinkNotice`,
    //   data
    // );
  },
  salesEnquirySendReply: async ({ commit, rootState }, payload) => {
    const response = await axios.post(
      `${rootState.axios.API}mailing/salesEnquiryReply`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    return response.data;
  },
};
